import React, { useEffect, useCallback, useState, useRef } from 'react'
import { Typography } from '@material-ui/core'
import { Button } from 'sputnik-ui'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { MainTemplate, StyledButtonsList } from 'components'
import { ExcludeNonAdmin } from 'utils/helpers'
import { useTranslation } from 'react-i18next'
import EmergenciesList from 'components/organisms/EmergenciesList'
import CreateEmergencyCallModal from 'components/organisms/CreateEmergencyCallModal'
import CreateEmergencyUnlockModal from 'components/organisms/CreateEmergencyUnlockModal'

function EmergencyHomePage({ userCompanyUuid, partnerCurrent, user }) {
  const { t } = useTranslation(['common', 'emergency'])
  const [createCallModal, setCreateCallModal] = useState(false)
  const toggleCreateCallModal = () => {
    setCreateCallModal(!createCallModal)
  }

  const [createUnlockModal, setCreateUnlockModal] = useState(false)
  const toggleCreateUnlockModal = () => {
    setCreateUnlockModal(!createUnlockModal)
  }
  return (
    <MainTemplate>
      <StyledButtonsList>
        <ExcludeNonAdmin authUser={user}>
          <Button
            secondary
            rounded
            component={Link}
            to="/emergency_app/admin"
            style={{
              position: 'relative',
            }}
          >
            {t('common:open_admin')}
          </Button>
        </ExcludeNonAdmin>
        <Button primary variant="v2" onClick={toggleCreateUnlockModal}>
          {t('emergency:button:create_new_unlock')}
        </Button>
        <Button primary variant="v2" onClick={toggleCreateCallModal}>
          {t('emergency:button:create_new_call')}
        </Button>
      </StyledButtonsList>
      <Typography variant="h5" style={{ marginBottom: '1rem' }}>
        {t('emergency:homepage:title')}
      </Typography>
      <EmergenciesList currentUser={user} />
      <CreateEmergencyCallModal
        open={createCallModal}
        handleClose={toggleCreateCallModal}
        currentUser={user}
      />
      <CreateEmergencyUnlockModal
        open={createUnlockModal}
        handleClose={toggleCreateUnlockModal}
        currentUser={user}
      />
    </MainTemplate>
  )
}

const mapStateToProps = (state) => {
  const { auth, partners } = state

  return {
    userCompanyUuid: auth.user.company.uuid,
    dataCurrent: partners.current,
    user: auth.user,
  }
}

export default connect(mapStateToProps)(withRouter(EmergencyHomePage))
